module.exports = __webpack_public_path__ + "static/media/about-eachother.d83b9d16.svg";